var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sword-layout',[_c('div',{staticClass:"feedback"},[_c('feedback-screen',{attrs:{"feedback-name":"callEnded","show-footer":false},on:{"rejoin":_vm.rejoin}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }